import { sortAndFilterData } from '../../features/table';

const { createFilter } = sortAndFilterData;

export const createFilters = (shutdowns, columnKeys) =>
  (shutdowns || []).reduce((acc, shutdown) => {
    createFilter({
      shutdown,
      result: acc,
      columnKey: columnKeys.reasonName,
      dataIndex: 'alertReason',
    });

    createFilter({
      shutdown,
      result: acc,
      columnKey: columnKeys.typeName,
      dataIndex: 'type',
    });

    return acc;
  }, {});
